export default {
  name: "Products"
}
